/**
 * Module imports.
 */
import cssVars from 'css-vars-ponyfill';



/**
 * Class for polyfilling CSS variables in old browsers.
 *
 * @class   CSSVariables (name)
 */
export class CSSVariables
{
	/**
	 * Adds event listeners.
	 */
	static addListeners()
	{
		// Wait for DOMContentLoaded
		$( document ).ready(
			() =>
			{
				// Call the poyfill once again, just in case
				CSSVariables.polyfill();
			}
		);
	}



	/**
	 * Polyfill the variables.
	 */
	static polyfill()
	{
		// Call the polyfill
		cssVars();
	}
}




// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/polyfills/css-variables/css-variables.js